/**
 * Root Reducer
 */
import { combineReducers } from 'redux';

// Import Reducers
import auth from './Auth';
import filter from './Filter';
import errors from './Error';
import company from './Company';
import context from './Initial';

// Combine all reducers into one root reducer
export default combineReducers({
  auth,
  errors,
  filter,
  context,
  company
});



// WEBPACK FOOTER //
// ./client/src/reducers/index.js